export const getWindowSize = () => {
  const isWindowAvailable = typeof window !== "undefined";

  return {
    height: isWindowAvailable ? window.innerHeight : 0,
    width: isWindowAvailable ? window.innerWidth : 0
  };
};
